import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { Div } from 'client/widget-components/basicComponents';
import type { CSSProperties } from 'react';
import React, { FC } from 'react';
import { SearchDropdown } from '../SearchDropdown/SearchDropdown';
import { SearchInput } from '../SearchInput/SearchInput';
import type { SearchPopupContentProps } from '../types';

export const SearchPopupContentSquare: FC<SearchPopupContentProps> = ({
    inputRef,
    styles,
    placeholder,
    inputValue,
    onInputChange,
    onInputFocus,
    onClosePopup,
    collections,
    isResultsShown,
    isLoading,
    fetchMore,
    animatedBlockRef,
    animationState,
}) => (
    <Div
        styles={[contentDefaultStyles, styles?.popup]}
        ref={animatedBlockRef}
        style={TRANSITION_STYLES[animationState]}
        data-grab='collection-search-widget-popup'
    >
        <SearchInput
            inputRef={inputRef}
            styles={{
                ...styles,
                inputWrapper: inputWrapperStyles,
            }}
            value={inputValue}
            placeholder={placeholder}
            onChange={onInputChange}
            onFocus={onInputFocus}
            onClose={onClosePopup}
        />
        <SearchDropdown
            collections={collections}
            styles={styles}
            isResultsShown={isResultsShown}
            isLoading={isLoading}
            fetchMore={fetchMore}
        />
    </Div>
);

const inputWrapperStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        borderBottom: '1px solid #E2E2E2',
    },
};

const contentDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        position: 'relative',
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '100vh',
        transition: `all 0.2s linear`,
        marginTop: '-200px',
        opacity: 0,
    },
};

const TRANSITION_STYLES: Record<string, CSSProperties> = {
    entering: { marginTop: 0, opacity: 1 },
    entered: { marginTop: 0, opacity: 1 },
    exiting: { marginTop: '-200px', opacity: 0 },
    exited: { marginTop: '-200px', opacity: 0, height: 0, overflow: 'hidden' },
};
